export const CLOSING_IT = {
  header: {
    title: 'Assunzioni',
    subtitle:
      'Questa sezione riepiloga i <strong>talenti che hanno accettato la tua offerta</strong>.<br/><br/>A seconda dei permessi del tuo account, possono essere inclusi anche i dettagli dei costi e la documentazione associata.',
  },
  bingoHeader: {
    label: 'Avete assunto',
    sublabel: '',
  },
  links: {
    resignation_letter: 'Lettera di dimissioni',
    commitment_letter: 'Impegnativa assunzione',
    prospect: 'Vedi prospetto',
  },
  tag: {
    text: 'Assunzione il {{hiring_date}}',
  },
};
